var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('vue-headful',{attrs:{"title":"Centro Social Paroquial da Brandoa","description":"Website oficial do Centro Social Paroquial da Brandoa"}}),_c('Nav',{attrs:{"user-type":_vm.getUserType()}}),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }